import React, { forwardRef, useContext, useImperativeHandle, useState } from 'react'
import { Lock, Person } from 'react-bootstrap-icons';
import { logo } from '../../pdf/Imges';
import { Modal, Spinner } from 'react-bootstrap';
import { RechercheContext } from '../Recherche';

const Formulaire = forwardRef((props, ref) => {

    const [context, setContext] = useState('');
    const provider = useContext(RechercheContext);

    useImperativeHandle(ref, () => ({
        rechercher() {
            props.execute(1, context);
        }
    }));
    const [formData, setFormData] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const submitHandler = (evt) => {
        evt.preventDefault();
        if (!context) {
            alert("Choisez le context de recherche");
            return;
        }
        provider.updateForm(formData);
    }

    return (
        <div className={'d-flex align-items-center justify-content-center' + (!props.display ? ' d-none' : '')}>
            <div>
                <div className='card card-body shadow'>
                    <form className="login-form" onSubmit={submitHandler} style={{ width: '40rem' }}>
                        <div className='d-flex justify-content-between mb-4'>
                            <div><h4 className='text-center text-muted'>Recherche</h4></div>
                            <div>
                                <select className='form-select' onChange={evt => setContext(evt.target.value)}>
                                    <option value=''>-- Contexte de recherche --</option>
                                    <option value="tra">Tanzanie</option>
                                    <option value="zra">Zambie</option>
                                    <option value="dgda">RDC/KATANGA</option>
                                </select>
                            </div>
                        </div>

                        <Input label={"Transport"} name="transport" placeholder="Identité du moyen de transport / conteneurs" onChange={handleChange} />
                        <Input label={"Importeur"} name="importateur" placeholder="Nom de l'importateur" onChange={handleChange} />
                        <Input label={"Exportateur"} name="exportateur" placeholder="Nom de l'exportateur" onChange={handleChange} />
                        <Input label={"Marchandise"} name="goods" placeholder="Description de la marchandise" onChange={handleChange} />
                        <Input label={"Tarif"} name="hs_code" placeholder="Position tarifaire" onChange={handleChange} />
                        <Input label={"Déclaration"} name="declaration" placeholder="Numéro déclaration / BL" onChange={handleChange} />
                        <div className='input-group mb-2'>
                            <span className='input-group-text'>Période</span>
                            <input className='form-control' type='date' name='periode_begin' onChange={handleChange} />
                            <input className='form-control' type='date' name='periode_limite' onChange={handleChange} />
                        </div>

                        <input className='form-control mb-2' type='number' min={1} max={1000} name='limit' required onChange={handleChange} />
                        <div className='form-group text-center'>
                            <button type='submit' className='btn btn-success mx-2' disabled={props.waiting}>
                                {props.waiting ? <Spinner /> : "Rechercher"}
                            </button>
                            <button type='reset' className='btn btn-secondary'>
                                Effacer
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )

    return (
        <div className={'d-flex align-items-center justify-content-center' + (!props.display ? ' d-none' : '')} style={{ backgroundColor: 'Window', position: 'absolute', minWidth: '100%', minHeight: '100%' }}>
            <div>
                <div className='text-center mb-5'>
                    <img src={logo} width={200} />
                </div>
                <div className='card card-body shadow'>
                    <form className="login-form" onSubmit={submitHandler} style={{ width: '40rem' }}>
                        <div className='d-flex justify-content-between mb-4'>
                            <div><h4 className='text-center text-muted'>Recherche</h4></div>
                            <div>
                                <select className='form-select' onChange={evt => setContext(evt.target.value)}>
                                    <option value=''>-- Contexte de recherche --</option>
                                    <option value="tra">Tanzanie</option>
                                    <option value="zra">Zambie</option>
                                    <option value="dgda">RDC/KATANGA</option>
                                </select>
                            </div>
                        </div>

                        <Input label={"Transport"} name="transport" placeholder="Identité du moyen de transport" onChange={handleChange} />
                        <Input label={"Importeur"} name="importateur" placeholder="Nom de l'importateur" onChange={handleChange} />
                        <Input label={"Exportateur"} name="exportateur" placeholder="Nom de l'exportateur" onChange={handleChange} />
                        <Input label={"Marchandise"} name="goods" placeholder="Description de la marchandise" onChange={handleChange} />
                        <Input label={"Tarif"} name="hs_code" placeholder="Position tarifaire" onChange={handleChange} />
                        <div className='input-group mb-2'>
                            <span className='input-group-text'>Période</span>
                            <input className='form-control' type='date' name='periode_begin' onChange={handleChange} />
                            <input className='form-control' type='date' name='periode_limite' onChange={handleChange} />
                        </div>

                        <input className='form-control mb-2' type='number' min={1} max={1000} name='limit' required onChange={handleChange} />
                        <div className='form-group text-center'>
                            <button type='submit' className='btn btn-success mx-2' disabled={props.waiting}>
                                {props.waiting ? <Spinner /> : "Rechercher"}
                            </button>
                            <button type='reset' className='btn btn-secondary'>
                                Effacer
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )

    return (
        <Modal
            show={props.display}
            onHide={() => provider.setOnForm(false)}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton />
            <Modal.Body>
                <form className="login-form" onSubmit={submitHandler}>
                    <div className='d-flex justify-content-between mb-4'>
                        <div><h4 className='text-center text-muted'>Recherche</h4></div>
                        <div>
                            <select className='form-select' onChange={evt => setContext(evt.target.value)}>
                                <option value=''>-- Contexte de recherche --</option>
                                <option value="tra">Tanzanie</option>
                                <option value="zra">Zambie</option>
                                <option value="dgda">RDC/KATANGA</option>
                            </select>
                        </div>
                    </div>

                    <Input label={"Transport"} name="transport" placeholder="Identité du moyen de transport" onChange={handleChange} />
                    <Input label={"Importeur"} name="importateur" placeholder="Nom de l'importateur" onChange={handleChange} />
                    <Input label={"Exportateur"} name="exportateur" placeholder="Nom de l'exportateur" onChange={handleChange} />
                    <Input label={"Marchandise"} name="goods" placeholder="Description de la marchandise" onChange={handleChange} />
                    <Input label={"Tarif"} name="hs_code" placeholder="Position tarifaire" onChange={handleChange} />
                    <div className='input-group mb-2'>
                        <span className='input-group-text'>Période</span>
                        <input className='form-control' type='date' name='periode_begin' onChange={handleChange} />
                        <input className='form-control' type='date' name='periode_limite' onChange={handleChange} />
                    </div>

                    <input className='form-control mb-2' type='number' min={1} max={1000} name='limit' required onChange={handleChange} />
                    <div className='form-group text-center'>
                        <button type='submit' className='btn btn-success mx-2' disabled={props.waiting}>
                            {props.waiting ? <Spinner /> : "Rechercher"}
                        </button>
                        <button type='reset' className='btn btn-secondary'>
                            Effacer
                        </button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
})

function Input({ label, name, placeholder, onChange }) {
    return (
        <div className='input-group mb-2'>
            <span className='input-group-text' style={{ width: '120px' }}>
                {label}
            </span>
            <input className='form-control' type="text" placeholder={placeholder} name={name} onChange={onChange} />
        </div>
    )
}

export default Formulaire;


const Child = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({
        myMethod() {
            console.log('Méthode appelée depuis le parent !');
        }
    }));

    return (
        <div>
            <p>Je suis le composant enfant.</p>
        </div>
    );
});